import React from 'react';
import PropTypes from 'prop-types';
import { terms as t } from '../../../constants';
import { phone, email } from '@lwt-helix/helix-icon/outlined';
import { agentProductionTerms as apt, trademark } from '../../../../constants';
import { useCommonStore } from '../../../../store/store';
import { getCommaSeparatedTextByKeyFields } from '../../../../common/helpers/object';
import { useMarketDynamicsStore } from '../../../../store/marketDynamics/store';
import { usePDFStore } from '../../../../store/pdf/store';
import { settingsByTab } from '../../../helpers/dashboard';
import { agentDetailFullAddress, normalizePhoneNumber } from '../../../helpers/pdf';
import { isAgentMetrics } from '../../../../constants/app';

const Header = ({
    listingViewId,
    timeFrameTitle,
    listingViewTitle,
    listingTypeId,
    isComparisonSetView,
    selectedComparisonSet,
    areaTypeTitle,
    officeListName,
    config,
    isOverview,
    selectedTabName,
    agentData,
}) => {

    const overviewStatus = useMarketDynamicsStore(state => state.overviewStatus);
    const logoSrc = usePDFStore((state) => state.logoSrc);

    const viewTitle = t[listingViewId] ?? listingViewTitle;
    const headerOverviewTabName = isOverview ? `- ${Object.keys(settingsByTab)[overviewStatus.currentTab]} ` : '';
    const headerTitle = config.getHeaderTitle(timeFrameTitle, {
        areaTypeTitle,
        isComparisonSetView,
        selectedComparisonSet,
        listingTypeId,
        headerOverviewTabName,
        isAgentMetrics
    })

    const moduleTitle = config.moduleTitle(selectedTabName);

    const officeList = config.shouldShowOfficeListHeader ? `(${officeListName})` : '';

    const {
        getUserAndOfficeInfo
    } = useCommonStore(state => ({
        getUserAndOfficeInfo: state.getUserAndOfficeInfo
    }));

    const userAndOfficeInfo = getUserAndOfficeInfo();

    const { name, phoneNumber, emailAddress, officeId } = userAndOfficeInfo;
    const addressHeaderText = getCommaSeparatedTextByKeyFields(
        userAndOfficeInfo,
        ['street1', 'city', 'stateCode', 'zipCode']
    );

    return (
        <div className='header'>
            <div className='flex justify-between'>
                <p>
                    <b className={`office-name ${(isAgentMetrics && config.hasAgentDetailHeader) ? 'office-name-padded' : ''}`}>{name}</b><br />
                    {!(isAgentMetrics && config.hasAgentDetailHeader) && (
                        <>
                            <span className='address'>{addressHeaderText}</span><br />
                            <span className='contact-item'>
                                <span className='icon'>{phone({ className: 'contact-icon' })}</span>{phoneNumber}
                            </span>
                            <span className='contact-item'>
                                <span className='icon'>{email({ className: 'contact-icon' })}</span>{emailAddress}
                            </span>
                        </>
                    )}
                </p>
                {logoSrc && (<img src={logoSrc} className='logo-pdf' />)}
            </div>
            <div className="header-divider"></div>
            <div className="header-title-container">
                <div className="header-title">
                    {moduleTitle} {officeList} <span className="header-title-separator"></span> {viewTitle} {headerTitle}
                </div>
                <div className='header-subtitle'>
                    <strong>
                        {config.getBrandName(isAgentMetrics)}<sup>{trademark}</sup> {t.report}
                    </strong>
                </div>
            </div>
            {config?.hasAgentDetailHeader && <div className="agent-info-container">
                <div>
                    <b className='agent-name'>{agentData?.agentName}</b><br />
                    <span className='agent-id'>{apt.agentId}: {agentData.agentId}</span>
                </div>

                <div className="additional-agent-info">
                    <div>
                        <span>{agentData?.officeName} ({agentData?.officeId || officeId})</span><br />
                        <span>{agentDetailFullAddress(agentData)}</span>
                    </div>
                    <div>
                        <span>{agentData?.agentEmail}</span><br />
                        {!isAgentMetrics && <span>{apt.officeCounty}: {agentData?.officeCounty}</span>}
                    </div>
                    {!isAgentMetrics && <div>
                        <span>Bus: {normalizePhoneNumber(agentData?.agentPhone1)}</span><br />
                        <span>C: {normalizePhoneNumber(agentData?.agentPhone2)}</span>
                    </div>}
                </div>
            </div>}
        </div>
    );
};

Header.propTypes = {
    module: PropTypes.string,
    listingViewId: PropTypes.string,
    timeFrameTitle: PropTypes.object,
    listingViewTitle: PropTypes.string,
    isComparisonSetView: PropTypes.bool,
    listingTypeId: PropTypes.string,
    selectedComparisonSet: PropTypes.object,
    areaTypeTitle: PropTypes.string,
    officeListName: PropTypes.string,
    config: PropTypes.object,
    isOverview: PropTypes.bool,
    selectedTabName: PropTypes.string,
    agentData: PropTypes.object,
};

export default Header;
